/* eslint-env browser */

import { WebsocketProvider } from "y-websocket";
// import { WebrtcProvider } from "y-webrtc";
import { IndexeddbPersistence } from "y-indexeddb";
import { v4 as uuidv4 } from "uuid";
import * as Y from "yjs";
import { GetObject } from "./utils";
const Globals = require("./globals");

require("./canvas");
require("./defaults");
require("./elements");

const { default: ConfigurePanZoom, setZoomTo } = require("./panzoom");

ConfigurePanZoom();

// TODO
// Collab using only stickies

// TODO - Shortcuts
// copy paste
// qwer... - colors
// f front
// b back
// a normal
// s large
// z/y label
// x text
// undo redo

const myID = uuidv4();
const doc = new Y.Doc();

const sp = new URLSearchParams(window.location.search);

const params = new Proxy(sp, {
  get: (searchParams, prop) => searchParams.get(prop),
});

let boardId = uuidv4();

if (params.board) {
  boardId = params.board;
} else {
  console.log(boardId);
  sp.set("board", boardId);
  window.location.search = sp.toString();
}

// const provider = new WebrtcProvider(boardId, doc, {
//   password: "optional-room-password",
// });

const websocketProvider = new WebsocketProvider(
  "wss://backend-divine-lake-6033.fly.dev",
  boardId,
  doc
);

websocketProvider.on("sync", function (isSynced) {
  console.log("is synced: ", isSynced);

  // console.log(Globals.elements);
  if (!isSynced) return;

  // init();
  // Globals.canvas.requestRenderAll();
});

// Globals.awareness = websocketProvider.awareness;

// // You can observe when a user updates their awareness information
// Globals.awareness.on("change", (changes) => {
//   // Whenever somebody updates their awareness information,
//   // we log all awareness information from all users.
//   console.log(Array.from(Globals.awareness.getStates().values()));
// });

// Globals.awareness.setLocalStateField("user", {
//   // Define a print name that should be displayed
//   name: "Emmanuelle Charpentier",
//   // Define a color that should be associated to the user:
//   color: "#ffb61e", // should be a hex color
// });

init();

// TODO - Add toggle (board settings drawer or smth) so anyone can disable and purge local storage
// const dbProvider = new IndexeddbPersistence(boardId, doc);

// dbProvider.on("synced", () => {
//   console.log("loaded changes from db");
// });

function init() {
  console.log("initializing...");

  Globals.elements = doc.getMap("board-updates");

  const undoManager = new Y.UndoManager(Globals.elements);

  Mousetrap.bind(["command+z", "ctrl+z"], function (e) {
    undoManager.undo();
  });

  const d = Date.now();

  Globals.elements.observe((event) => {
    event.changes.keys.forEach((change, key) => {
      if (change.action === "add") {
        let obj = Globals.elements.get(key);

        if (myID === obj.sender) {
          return;
        }

        const existing = GetObject(obj.id);

        // TODO - need better way of figuring out if event is ours
        if (existing) return;

        obj = {
          ...obj,
          myUpdate: true,
        };

        fabric.util.enlivenObjects([obj], (objects) => {
          Globals.canvas.add(...objects);
        });
      }

      if (change.action === "update") {
        let obj = Globals.elements.get(key);

        if (myID === obj.sender) {
          return;
        }

        const existing = GetObject(obj.id);

        if (!existing) return;

        if (existing.type === "sticky") {
          fabric.Sticky.fromObject(obj, (enl) => {
            const index = Globals.canvas.getObjects().indexOf(existing);

            Globals.canvas.remove(existing);
            Globals.canvas.insertAt(enl, index, false);
          });
        } else {
          existing.set({
            ...obj,
          });
        }

        Globals.canvas.renderAll();
      }

      if (change.action === "delete") {
        var elem = GetObject(key);

        if (!elem) return;
        Globals.canvas.remove(elem);
        Globals.canvas.requestRenderAll();
      }
    });
  });

  Globals.canvas.on("sticky:added", function (e) {
    var obj = e.target.toObject();

    if (!obj) return;

    Globals.elements.set(obj.id, {
      ...obj,
      sender: myID,
    });

    e.target.isMyElem = false;
  });

  Globals.canvas.on("sticky:removed", (e) => {
    Globals.elements.delete(e.target.id);
  });

  Globals.canvas.on("object:removed", (e) => {
    if (e.target.type === "StickyEdit") {
      var obj = GetObject(e.target.parent);

      Globals.elements.set(obj.id, {
        ...obj.toObject(),
        sender: myID,
      });

      e.target.myUpdate = false;
    }
  });

  Globals.canvas.on("sticky:changed", (e) => {
    if (!e.target.parent) return;

    var obj = GetObject(e.target.parent);

    Globals.elements.set(obj.id, {
      ...obj.toObject(),
      sender: myID,
    });

    e.target.myUpdate = false;
  });

  Globals.canvas.on("object:modified", function (e) {
    if (e.target.type === "activeSelection") {
      Globals.canvas.getActiveObjects().forEach((elem) => {
        notifyModify(elem, e.target.getCenterPoint());
      });

      return;
    }

    notifyModify(e.target);
  });
}
const notifyModify = (target, pos) => {
  if (target.externalUpdate) {
    target.externalUpdate = false;
    return;
  }

  var obj = target.toObject();

  if (!obj) return;

  if (pos) {
    obj = {
      ...obj,
      left: obj.left + pos.x,
      top: obj.top + pos.y,
    };
  }

  Globals.elements.set(obj.id, {
    ...obj,
    sender: myID,
  });
};

window.Create = (what) => {
  const cursor = what === 2 || what === 3 ? "text" : "crosshair";

  Globals.canvas.defaultCursor = cursor;
  Globals.createType = what;
  Globals.create = true;
};

function getItem(key) {
  let data = window.localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
}

function setItem(key, item) {
  window.localStorage.setItem(key, JSON.stringify(item));
}
